import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import HotelSearchWeb from "./layouts/HotelSearch.web";
import HotelSearchMobile from "./layouts/HotelSearch.mobile";
import hotelsHeroImage from "src/assets/images/SearchPages/hotels.png";

const HotelSearchMainPageComponent = withConditionalComponent(HotelSearchWeb, HotelSearchMobile);

export default function HotelSearch() {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  return <HotelSearchMainPageComponent trigger={isLargeScreen} props={{ imgUrl: hotelsHeroImage }} />;
}
